/* eslint-disable */
import React, { useState, useEffect } from "react";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import SessionData from "../../../services/session-data";

export default function DeleteStaff(props: any) {
  const [open, setOpen] = useState(false);
  const [branchName, setBranchName] = useState<string>("");
  const [city, setCity] = useState<string>("");
  let message = "";

  const handleClose = () => {
    setOpen(false);
    props.parentCallback("Branch Not Deleted!!");
  };

  useEffect(() => {
    // eslint-disable-next-line no-lone-blocks
    {
      props.deleteOpen ? setOpen(true) : setOpen(false);
    }
  }, []);

  const DeleteBranch = async () => {
    const sd = new SessionData();
    try {
      const res = await axios.delete(
        sd.getBaseURL() + "web-register/newbranch",
        {
          headers: {
            Authorization: "Bearer " + sd.getClientToken(),
            "staff-auth": "Bearer " + sd.getStaffToken(),
          },
        }
      );
      if (res.status == 200) {
        message = "Branch Deleted!";
      }
    } catch (err: any) {
      message = "Something Went Wrong";
    } finally {
      setBranchName("");
      setCity("");
      handleClose();
    }
  };

  const showTheDialog = () => {
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Delete Branch</DialogTitle>
          <DialogContent style={{ backgroundColor: "#eff9f0" }}>
            <DialogContentText>
              {/* showing articles in this load */}
              <label>
                Are you sure you want to delete this {branchName} branch?
              </label>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ backgroundColor: "#eff9f0" }}>
            <Button onClick={formValidation} color="primary" autoFocus>
              Yes
            </Button>
            <Button onClick={handleClose} color="primary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const formValidation = () => {
    DeleteBranch();
  };

  return <div>{open ? showTheDialog() : ""}</div>;
}
